import { useState, useCallback } from 'react';

export const useModals = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const handleOpenModal = useCallback(() => {
        setIsOpen(true);
    }, []);

    const handleCloseModal = useCallback(() => {
        setIsOpen(false);
    }, []);

    const handleOpenDeleteModal = useCallback((item) => {
        setSelectedItem(item);
        setIsDeleteOpen(true);
    }, []);

    const handleCloseDeleteModal = useCallback(() => {
        setIsDeleteOpen(false);
        setSelectedItem(null);
    }, []);

    return {
        isOpen,
        isDeleteOpen,
        selectedItem,
        handleOpenModal,
        handleCloseModal,
        handleOpenDeleteModal,
        handleCloseDeleteModal
    };
}; 